import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><path d=\"M136.533333 85.333333c-28.2752 0-51.2 22.9248-51.2 51.2v750.933334c0 28.2752 22.9248 51.2 51.2 51.2h750.933334c28.2752 0 51.2-22.9248 51.2-51.2V136.533333c0-28.2752-22.9248-51.2-51.2-51.2H136.533333z m0-51.2h750.933334c56.554667 0 102.4 45.845333 102.4 102.4v750.933334c0 56.554667-45.845333 102.4-102.4 102.4H136.533333c-56.554667 0-102.4-45.845333-102.4-102.4V136.533333C34.133333 79.978667 79.978667 34.133333 136.533333 34.133333z m349.866667 452.266667V298.666667a25.6 25.6 0 0 1 51.2 0v187.733333h187.733333a25.6 25.6 0 0 1 0 51.2h-187.733333v187.733333a25.6 25.6 0 0 1-51.2 0v-187.733333H298.666667a25.6 25.6 0 0 1 0-51.2h187.733333z\" fill=\"#cdcdcd\" p-id=\"16321\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svg/add.svg
// module id = 3Fcy
// module chunks = 317